import React, { useState, useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";
import leftArrowSvg from "../../../Assets/leftArrowSvg.svg";
import rightArrowSvg from "../../../Assets/rightArrowSvg.svg";
import brand_logo from "../../../Assets/brand_logo.png";
import pattern1 from "../../../Assets/pattern1.png";
import pattern2 from "../../../Assets/pattern2.png";
import pattern3 from "../../../Assets/pattern3.png";
import pattern4 from "../../../Assets/pattern4.png";
import { ChromePicker } from "react-color";
import { Eye, X, Upload, FileImage } from "lucide-react";
import Modal from "react-bootstrap/Modal";
import {
  get_all_data_onboarding,
  insert_update_business_data_onboarding,
  server_post_data,
} from "../../../ServiceConnection/serviceconnection";
import { handleError } from "../../../CommonJquery/CommonJquery";
import remove_uploaded_image from "../../../Assets/remove_uploaded_image.png";
import "../../CSS/NewOnboading/Step6.css";
export default function Step6Page({ onBack, onNext }) {
  const fileInputRef = useRef(null);
  const [error, setError] = useState(false);

  const [logo, setLogo] = useState();
  const [isLogoRemoved, setIsLogoRemoved] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [bussinesText, setbussinesText] = useState("");
  const [tagLine, settagLine] = useState("");

  // State for QR code styling
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [selectedFrame, setSelectedFrame] = useState("frameBox1"); // Default to 'No Frame'
  const [image, setImage] = useState([]);
  const [logoError, setLogoError] = useState(false);
  const [businessNameError, setBusinessNameError] = useState(false);
  const [taglineError, setTaglineError] = useState(false);
  const [shakeBusiness, setShakeBusiness] = useState(false);
  const [shakeTagline, setShakeTagline] = useState(false);

  // QR Code refs
  const qrCodeRef = useRef(null);
  const modalQrCodeRef = useRef(null);
  const qrInstance = useRef(null);
  const [color, setColor] = useState({ r: 100, g: 255, b: 0, a: 1 });
  const [styles, setStyles] = useState({
    backgroundColor: "#ec5e3a",
    textColor: "#00000",
    ctaColor: "#ff5722",
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  // Map patterns to dot styles
  const patternToDotStyle = {
    [pattern1]: "dots",
    [pattern2]: "rounded",
    [pattern3]: "classy",
    [pattern4]: "classy-rounded",
    null: "rounded", // Default
  };
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // Effect to create and update QR code when styling changes
  useEffect(() => {
    console.log(selectedFrame);
    const createQRCode = (containerRef) => {
      if (!containerRef.current) return;

      // Clear previous content
      containerRef.current.innerHTML = "";

      // Create new QR code instance
      const currentDotStyle = selectedPattern
        ? patternToDotStyle[selectedPattern]
        : "rounded";

      const qrCode = new QRCodeStyling({
        width: 300,
        height: 300,
        data: "https://www.wowreviews.co",

        shape: selectedFrame === "frameBox circularFrame" ? "circle" : "square",
        // image: logo && !isLogoRemoved ? logo : undefined,
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 10,
        },
        dotsOptions: {
          type: currentDotStyle,
          color: "#000",
        },
        cornersSquareOptions: {
          type: "extra-rounded",
          color: "#000",
        },
        backgroundOptions: {
          color: "#fff",
        },
      });

      // Append to container
      qrCode.append(containerRef.current);

      // Style the canvas and its parent container
      setTimeout(() => {
        const canvas = containerRef.current.querySelector("canvas");
        if (canvas) {
          canvas.style.width = "100%";
          canvas.style.height = "100%";

          // Apply styling to the canvas
          if (selectedFrame === "frameBox circularFrame") {
            canvas.style.borderRadius = "50%";
            canvas.style.clipPath = "circle(50% at center)";
          } else if (selectedFrame === "frameBox") {
            canvas.style.borderRadius = "12px";
            canvas.style.clipPath = "none";
          } else {
            canvas.style.borderRadius = "0";
            canvas.style.clipPath = "none";
          }
        }
      }, 100);

      return qrCode;
    };

    // Create QR code in main view
    if (qrCodeRef.current) {
      qrInstance.current = createQRCode(qrCodeRef);
    }

    // Create QR code in modal if modal is open
    if (showModal && modalQrCodeRef.current) {
      createQRCode(modalQrCodeRef);
    }
  }, [selectedPattern, selectedFrame, logo, isLogoRemoved, showModal]);

  // Handle pattern selection
  const handlePatternSelect = (patternImage) => {
    setSelectedPattern(patternImage);
  };

  // Handle frame selection
  const handleFrameSelect = (frameClass) => {
    setSelectedFrame(frameClass);
  };

  const handlePreviewMobile = () => {
    setShowModal(!showModal);
  };

  // Custom styles for the frames in the QR display
  const getFrameStyles = () => ({
    width: "180px",
    height: "180px",
    borderRadius:
      selectedFrame === "frameBox circularFrame"
        ? "50%"
        : selectedFrame === "frameBox"
          ? "12px"
          : "0",
    overflow: "hidden",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  });

  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [businessTypes, setbusinessTypes] = useState([]);
  const [businessImage, setbusinessImage] = useState("");
  const [businessTypes2, setbusinessTypes2] = useState([]);
  const [businessImage2, setbusinessImage2] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [textColor, setTextColor] = useState("#333");
  const [bgColor, setBgColor] = useState("#EC5E3A");

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("flag", "6");
    await server_post_data(get_all_data_onboarding, fd)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          if (final_data.onboarding_data.length > 0) {
            setbusinessTypes(final_data.onboarding_data[0]);
            if (
              final_data.onboarding_data[0].business_name !== "" &&
              final_data.onboarding_data[0].business_name !== null
            )
              setbussinesText(final_data.onboarding_data[0].business_name);
            if (
              final_data.onboarding_data[0].business_tagline !== "" &&
              final_data.onboarding_data[0].business_tagline !== null
            )
              settagLine(final_data.onboarding_data[0].business_tagline);
            setSelectedFrame(final_data.onboarding_data[0].frame_name);
            setSelectedPattern(final_data.onboarding_data[0].parttan_name);
            if (
              final_data.onboarding_data[0].application_text_color !== "" &&
              final_data.onboarding_data[0].application_text_color !== null
            ) {
              setTextColor(
                final_data.onboarding_data[0].application_text_color,
              );
            }
            if (
              final_data.onboarding_data[0].application_color !== "" &&
              final_data.onboarding_data[0].application_color !== null
            ) {
              setBgColor(final_data.onboarding_data[0].application_color);
              setStyles({
                backgroundColor:
                  final_data.onboarding_data[0].application_color,
                textColor: final_data.onboarding_data[0].application_text_color,
                ctaColor: final_data.onboarding_data[0].application_color,
              });
            }

            if (final_data.onboarding_data[0].website_logo !== null) {
              setLogo(
                final_data.review_linkss_link +
                  final_data.onboarding_data[0].website_logo,
              );
              setIsLogoRemoved(false);
            } else {
              setIsLogoRemoved(true);
            }
          }
          setbusinessImage(final_data.review_linkss_link);

          setbusinessTypes2(final_data.review_linkss_data2);
          setbusinessImage2(final_data.review_linkss_link2);
          console.log("Data", final_data);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
  }, []);
  // Handle logo upload
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        // 2MB limit
        setLogoError("File size must be less than 2MB");
        setIsLogoRemoved(true); // No logo is set if file size exceeds limit
        return;
      }

      setImage(file);
      setIsUploading(true);
      setLogoError(false); // Clear any previous error
      setIsLogoRemoved(false); // Indicate logo is uploaded

      // Simulate upload progress
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        setUploadProgress(progress);
        if (progress >= 100) {
          clearInterval(interval);
          setIsUploading(false);
        }
      }, 100);

      const reader = new FileReader();
      reader.onload = (e) => {
        const logoUrl = e.target.result;
        setLogo(logoUrl);
        console.log("Uploaded Logo URL:", logoUrl); // Log the logo URL
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle drag over
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add("drag-over");
  };

  // Handle drag leave
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("drag-over");
  };

  // Handle drop
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("drag-over");

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];

      if (file.size > 2 * 1024 * 1024) {
        setLogoError("File size must be less than 2MB");
        return;
      }

      setImage(file);
      setIsUploading(true);
      setLogoError(false);

      // Simulate upload progress
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        setUploadProgress(progress);
        if (progress >= 100) {
          clearInterval(interval);
          setIsUploading(false);
        }
      }, 100);

      const reader = new FileReader();
      reader.onload = (e) => {
        setLogo(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleRemoveLogo = () => {
    setLogo(null);
    setImage(null);
    setUploadProgress(0);
    setIsUploading(false);
    setLogoError(false); // Clear error on remove
    setIsLogoRemoved(true); // Indicate no logo
    console.log("Logo Removed: No logo URL available");
  };
  const validateForm = () => {
    let isValid = true;

    if (!logo) {
      setLogoError("Please upload image"); // Set error message as requested
      console.log("❌ Logo check failed: No logo uploaded");
      isValid = false;
    } else {
      setLogoError(false);
      console.log("✅ Logo check passed: Logo URL =", logo);
    }

    if (!bussinesText.trim()) {
      setBusinessNameError(true);
      console.log("❌ Business name check failed");
      isValid = false;
    } else {
      setBusinessNameError(false);
      console.log("✅ Business name check passed");
    }

    if (!tagLine.trim()) {
      setTaglineError(true);
      console.log("❌ Tagline check failed");
      isValid = false;
    } else {
      setTaglineError(false);
      console.log("✅ Tagline check passed");
    }

    console.log("🎯 Final Form Validity:", isValid);
    return isValid;
  };

  const handleNext = async () => {
    const isValid = validateForm();
    if (!isValid) return;

    const currentDotStyle = selectedPattern
      ? patternToDotStyle[selectedPattern]
      : "rounded";

    setIsLoading(true);

    let fd_from = new FormData();
    fd_from.append("flag", "6");
    fd_from.append("parttan_name", currentDotStyle);
    fd_from.append("frame_name", selectedFrame);
    fd_from.append("website_logo_old", businessTypes.website_logo);
    fd_from.append("website_logo", image);
    fd_from.append("business_name", bussinesText);
    fd_from.append("business_tagline", tagLine);
    fd_from.append("application_color", styles.backgroundColor);
    fd_from.append("application_text_color", styles.textColor);

    try {
      const Response = await server_post_data(
        insert_update_business_data_onboarding,
        fd_from,
      );
      setIsLoading(false);
      let data = Response.message.split("~@~");
      const final_data = JSON.parse(data[1]);
      if (parseInt(data[0]) === 1) {
        handleError(final_data.message);
      } else {
        onNext(final_data.step_save);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleColorClick1 = (selectedColor, targetEl = null) => {
    const circles = document.querySelectorAll(".circles_color");
    circles.forEach((c) => c.classList.remove("active"));
    if (targetEl) targetEl.classList.add("active");

    const hexColor = rgbaToHex(selectedColor);

    setColor(selectedColor);
    setBgColor(hexColor);
    setStyles({
      ...styles,
      backgroundColor: hexColor,
      textColor: isLightColor(selectedColor) ? "#000000" : "#FFFFFF",
    });
  };

  const handleColorClick = (e, selectedColor) => {
    const circles = document.querySelectorAll(".circles_color");
    circles.forEach((c) => c.classList.remove("active"));
    e.currentTarget.classList.add("active");

    const hexColor = rgbaToHex(selectedColor);

    setColor(selectedColor);
    setBgColor(hexColor);
    setStyles({
      ...styles,
      backgroundColor: hexColor,
      textColor: isLightColor(selectedColor) ? "#000000" : "#FFFFFF",
    });
  };

  const isLightColor = ({ r, g, b }) => {
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 200;
  };

  const rgbaToHex = ({ r, g, b }) => {
    return (
      "#" +
      [r, g, b]
        .map((x) => {
          const hex = x.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("")
    );
  };

  console.log("Hello", logo);
  const stylesUpdLogo = {
    container: {
      maxWidth: "450px",
      margin: "0 auto",
      borderRadius: "8px",
    },

    uploadWrapper: {
      position: "relative",
    },
    uploadArea: {
      border: "2px dashed #d1d5db",
      borderRadius: "8px",
      padding: "10px 15px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.3s ease",
      backgroundColor: "#ffffff",
    },
    uploadAreaSuccess: {
      borderColor: "#86efac",
      backgroundColor: "#f0fdf4",
    },
    hiddenInput: {
      display: "none",
    },
    uploadContent: {
      marginTop: "23px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
    },
    imageContainer: {
      position: "relative",
    },
    uploadedImage: {
      width: "64px",
      height: "64px",
      objectFit: "contain",
      borderRadius: "4px",
    },
    removeButton: {
      position: "absolute",
      top: "-8px",
      right: "-8px",
      backgroundColor: "#ef4444",
      color: "white",
      border: "none",
      borderRadius: "50%",
      padding: "4px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background-color 0.2s ease",
    },
    uploadIcon: {
      color: "#3b82f6",
    },
    textContainer: {
      textAlign: "center",
    },
    primaryText: {
      color: "#4b5563",
      fontWeight: "500",
      margin: "0 0 2px 0",
    },
    secondaryText: {
      fontSize: "10px",
      color: "#9ca3af",
      margin: "0",
    },
    progressContainer: {
      width: "100%",
      marginTop: "1px",
      marginBottom: "10px",
    },
    progressHeader: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "14px",
      color: "#4b5563",
      marginBottom: "4px",
    },
    fileName: {
      fontWeight: "500",
    },
    percentage: {
      fontWeight: "500",
    },
    progressBarBg: {
      width: "100%",
      backgroundColor: "#e5e7eb",
      borderRadius: "9999px",
      height: "8px",
    },
    progressBar: {
      backgroundColor: "#3b82f6",
      height: "8px",
      borderRadius: "9999px",
      transition: "width 0.2s ease",
    },
    errorMessage: {
      marginTop: "12px",
      color: "#ef4444",
      fontSize: "14px",
      fontWeight: "500",
    },
  };

  return (
    <div className="tell_aboutSection custum_qr_width_step_6">
      <div
        className="bussiness_typeCard padingNone"
        style={{ position: "relative" }}
      >
        <div className="step7Div">
          <div className="height_ovr_flow_clss_step6">
            <div className="title_step_6">
              <h1>QR Display Customization</h1>
              <label className="step_6_subtitile">
                Personalize and finalize your QR code by adding your business
                details, brand colors, and downloading it to share with your
                customers.
              </label>
            </div>

            <div className="row">
              <div className="col-lg-8">
                <div className="customizer-panel">
                  <div className="scnPageLvl"></div>
                  <div className="d-flex gap-2 align-items-center h3HeadScanPage">
                    {error && (
                      <span style={{ color: "red" }} className="margin_errr">
                        (Please Fill all fields)
                      </span>
                    )}
                  </div>
                  {/* <p className="previewTXt">Preview</p> */}
                  <div className="mobilePreviewContainer">
                    <button
                      type="button"
                      className="mobilePreviews"
                      onClick={handlePreviewMobile}
                    >
                      <Eye size={16} />
                    </button>{" "}
                    <p>Preview</p>
                  </div>

                  <div className="row justi_center_clss">
                    <div className="row mb-xl-5 mb-lg-3">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Upload Logo</label>
                          <div style={stylesUpdLogo.container}>
                            <div style={stylesUpdLogo.uploadWrapper}>
                              {/* Upload Area - Always Visible */}
                              <div
                                style={{
                                  ...stylesUpdLogo.uploadArea,
                                  ...(logo
                                    ? stylesUpdLogo.uploadAreaSuccess
                                    : {}),
                                }}
                                className="upload-area"
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                                onClick={() => fileInputRef.current?.click()}
                              >
                                {/* Progress Bar */}
                                {isUploading && (
                                  <div style={stylesUpdLogo.progressContainer}>
                                    <div style={stylesUpdLogo.progressHeader}>
                                      <span style={stylesUpdLogo.fileName}>
                                        {image?.name}
                                      </span>
                                      <span style={stylesUpdLogo.percentage}>
                                        {uploadProgress}%
                                      </span>
                                    </div>
                                    <div style={stylesUpdLogo.progressBarBg}>
                                      <div
                                        style={{
                                          ...stylesUpdLogo.progressBar,
                                          width: `${uploadProgress}%`,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                )}
                                {/* File Input */}
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  onChange={handleLogoUpload}
                                  accept="image/png,image/jpg,image/jpeg,image/svg+xml"
                                  style={stylesUpdLogo.hiddenInput}
                                />

                                {/* Upload Icon and Text */}
                                <div style={stylesUpdLogo.uploadContent}>
                                  {logo ? (
                                    <div style={stylesUpdLogo.imageContainer}>
                                      <img
                                        src={logo}
                                        alt="Uploaded logo"
                                        style={stylesUpdLogo.uploadedImage}
                                      />
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleRemoveLogo();
                                        }}
                                        style={stylesUpdLogo.removeButton}
                                      >
                                        <X size={12} />
                                      </button>
                                    </div>
                                  ) : (
                                    <div style={stylesUpdLogo.uploadIcon}>
                                      <Upload size={32} />
                                    </div>
                                  )}

                                  <div style={stylesUpdLogo.textContainer}>
                                    <p style={stylesUpdLogo.primaryText}>
                                      {logo
                                        ? "Logo uploaded successfully!"
                                        : "📁 Drop your logo here or browse files"}
                                    </p>
                                    <p style={stylesUpdLogo.secondaryText}>
                                      PNG, JPG or SVG (Max. 2MB)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Error Message */}
                        {logoError && (
                          <div style={stylesUpdLogo.errorMessage}>
                            {logoError}
                          </div>
                        )}
                      </div>
                      <div className="col-md-8">
                        <div className="qr_buss_tag_div">
                          <div className="form-group">
                            <div className="w-100 d-flex justify-content-between align-items-center">
                              {" "}
                              <label>Business Name</label>{" "}
                              <div
                                style={{
                                  color:
                                    bussinesText.replace(/\s/g, "").length >= 25
                                      ? "red"
                                      : "green",
                                  fontSize: "12px",
                                  marginRight: "3px",
                                }}
                              >
                                {bussinesText.replace(/\s/g, "").length} / 25
                              </div>
                            </div>

                            <input
                              type="text"
                              className={`form-control ${
                                shakeBusiness ? "shake" : ""
                              }`}
                              placeholder="Enter Business Name"
                              value={bussinesText}
                              onChange={(e) => {
                                let inputValue = e.target.value;
                                const nonSpaceChars = inputValue.replace(
                                  /\s/g,
                                  "",
                                );
                                if (nonSpaceChars.length <= 25) {
                                  if (inputValue.length > 0) {
                                    inputValue =
                                      inputValue.charAt(0).toUpperCase() +
                                      inputValue.slice(1);
                                  }
                                  setbussinesText(inputValue);
                                  setBusinessNameError(false);
                                } else {
                                  setShakeBusiness(true);
                                  setTimeout(
                                    () => setShakeBusiness(false),
                                    500,
                                  );
                                }
                              }}
                            />

                            {businessNameError && (
                              <span className="text-danger">
                                Please Enter Business Name
                              </span>
                            )}
                          </div>

                          <div className="form-group">
                            <div className="w-100 d-flex justify-content-between align-items-center">
                              <label>Tagline</label>
                              <div
                                style={{
                                  color:
                                    tagLine.replace(/\s/g, "").length >= 35
                                      ? "red"
                                      : "green",
                                  fontSize: "12px",
                                  marginRight: "3px",
                                }}
                              >
                                {tagLine.replace(/\s/g, "").length} / 35
                              </div>
                            </div>

                            <input
                              type="text"
                              className={`form-control ${
                                shakeTagline ? "shake" : ""
                              }`}
                              placeholder="Enter Tagline"
                              value={tagLine}
                              onChange={(e) => {
                                let inputValue = e.target.value;
                                const nonSpaceChars = inputValue.replace(
                                  /\s/g,
                                  "",
                                );
                                if (nonSpaceChars.length <= 35) {
                                  if (inputValue.length > 0) {
                                    inputValue =
                                      inputValue.charAt(0).toUpperCase() +
                                      inputValue.slice(1);
                                  }
                                  settagLine(inputValue);
                                  setTaglineError(false);
                                } else {
                                  setShakeTagline(true);
                                  setTimeout(() => setShakeTagline(false), 500);
                                }
                              }}
                            />

                            {taglineError && (
                              <span className="text-danger">
                                Please Enter Tagline
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="brandAndFrameContnr">
                      <div className="col-lg-6">
                        <div className="brandColorClass">
                          <div className="form-group">
                            <label>Brand Color</label>
                            <div className="brand_color_semple">
                              <div
                                className="circles_color orenge"
                                style={{ backgroundColor: "#FFA500" }}
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 255,
                                    g: 165,
                                    b: 0,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color purple"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 91,
                                    g: 60,
                                    b: 213,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color red"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 198,
                                    g: 33,
                                    b: 33,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color green"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 34,
                                    g: 197,
                                    b: 94,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color yellow"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 234,
                                    g: 179,
                                    b: 8,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color lightOrenge"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 252,
                                    g: 128,
                                    b: 25,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color lightBlue"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 117,
                                    g: 167,
                                    b: 249,
                                    a: 1,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="custum_cllr_clss hiden_WEB">
                          <div className="form-group">
                            <label>Custom</label>
                            <div
                              className="cutm_color_div justiEndClass"
                              style={{ position: "relative" }}
                            >
                              <div
                                className="custum_color_circle"
                                style={{
                                  backgroundColor: `rgba(${color.r},${color.g},${color.b},${color.a})`,
                                }}
                                onClick={() => setShowPicker((prev) => !prev)}
                              ></div>

                              <div className="hexColorDIv">
                                {rgbaToHex(color).toUpperCase()}
                              </div>

                              {showPicker && (
                                <div
                                  ref={pickerRef}
                                  style={{
                                    position: "absolute",
                                    top: "50px",
                                    zIndex: 100,
                                  }}
                                >
                                  <ChromePicker
                                    color={color}
                                    onChange={(updatedColor) => {
                                      const { r, g, b, a } = updatedColor.rgb;
                                      const selectedColor = {
                                        r: r,
                                        g: g,
                                        b: b,
                                        a: a ?? 1,
                                      };
                                      handleColorClick1(selectedColor); // set color from picker
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="qrPtternContr web_show">
                          <label>QR Pattern Style</label>
                          <div className="QrPatternrow">
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern1 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern1)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern1
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <img src={pattern1} alt="Pattern 1" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern2 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern2)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern2
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <img src={pattern2} alt="Pattern 2" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern3 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern3)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern3
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <img src={pattern3} alt="Pattern 3" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern4 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern4)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern4
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <img src={pattern4} alt="Pattern 4" width="114" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 ">
                        <div className="custum_cllr_clss web_show">
                          {" "}
                          <div className="form-group">
                            <label>Custom</label>
                            <div
                              className="cutm_color_div justiEndClass"
                              style={{ position: "relative" }}
                            >
                              <div
                                className="custum_color_circle"
                                style={{
                                  backgroundColor: `rgba(${color.r},${color.g},${color.b},${color.a})`,
                                }}
                                onClick={() => setShowPicker((prev) => !prev)}
                              ></div>

                              <div className="hexColorDIv">
                                {rgbaToHex(color).toUpperCase()}
                              </div>

                              {showPicker && (
                                <div
                                  ref={pickerRef}
                                  style={{
                                    position: "absolute",
                                    top: "50px",
                                    zIndex: 100,
                                  }}
                                >
                                  <ChromePicker
                                    color={color}
                                    onChange={(updatedColor) => {
                                      const { r, g, b, a } = updatedColor.rgb;
                                      const selectedColor = {
                                        r: r,
                                        g: g,
                                        b: b,
                                        a: a ?? 1,
                                      };
                                      handleColorClick1(selectedColor); // set color from picker
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="qrPtternContr mobile_show">
                          <label>QR Pattern Style</label>
                          <div className="QrPatternrow">
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern1 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern1)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern1
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <img src={pattern1} alt="Pattern 1" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern2 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern2)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern2
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <img src={pattern2} alt="Pattern 2" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern3 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern3)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern3
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <img src={pattern3} alt="Pattern 3" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern4 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern4)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern4
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <img src={pattern4} alt="Pattern 4" width="114" />
                            </div>
                          </div>
                        </div>
                        <div className="qrFrameStleContnr">
                          <label>QR Frame Style</label>
                          <div className="QrPatternrow">
                            <div
                              className={
                                selectedFrame === "frameBox1" ? "selected" : ""
                              }
                              onClick={() => handleFrameSelect("frameBox1")}
                              style={{
                                cursor: "pointer",
                                padding: "5px",
                                border:
                                  selectedFrame === "frameBox1"
                                    ? "1px solid red"
                                    : "none",
                                borderRadius: "12px",
                              }}
                            >
                              <div className="frameBox1"></div>
                              <div className="frameLabel">No Frame</div>
                            </div>
                            <div
                              className={
                                selectedFrame === "frameBox" ? "selected" : ""
                              }
                              onClick={() => handleFrameSelect("frameBox")}
                              style={{
                                cursor: "pointer",
                                padding: "5px",
                                border:
                                  selectedFrame === "frameBox"
                                    ? "1px solid red"
                                    : "none",
                                borderRadius: "12px",
                              }}
                            >
                              <div className="frameBox"></div>
                              <div className="frameLabel">Rounded</div>
                            </div>
                            <div
                              className={
                                selectedFrame === "frameBox circularFrame"
                                  ? "selected"
                                  : ""
                              }
                              onClick={() =>
                                handleFrameSelect("frameBox circularFrame")
                              }
                              style={{
                                cursor: "pointer",
                                padding: "5px",
                                border:
                                  selectedFrame === "frameBox circularFrame"
                                    ? "1px solid red"
                                    : "none",
                                borderRadius: "12px",
                              }}
                            >
                              <div className="frameBox circularFrame"></div>
                              <div className="frameLabel">Circular</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-4 HiddenClss"
                style={{ position: "relative" }}
              >
                <div className="Step_6_QR_container">
                  <div className="qrScreenMobile m-auto">
                    <div className="logoSection">
                      <div className="logoCircle">
                        <img
                          src={logo || brand_logo}
                          className="dummyBussinesLogo"
                          title="Bussiness Logo"
                          alt="Logo"
                        />
                      </div>
                      <div className="businessInfo">
                        <h2>{bussinesText}</h2>
                        <p>{tagLine}</p>
                      </div>
                    </div>
                    <div
                      className="feedbackSection"
                      style={{ backgroundColor: bgColor }}
                    >
                      <p style={{ color: styles.textColor }}>
                        Please Provide your valuable
                      </p>
                      <h1 style={{ color: styles.textColor }}>Feedback</h1>
                    </div>
                    <div className="qrCodeContainer">
                      <div
                        className={selectedFrame}
                        style={{
                          ...getFrameStyles(),
                          clipPath:
                            selectedFrame === "frameBox circularFrame"
                              ? "circle(50% at center)"
                              : "none",
                        }}
                      >
                        <div
                          ref={qrCodeRef}
                          className="qrCodeScreen"
                          style={{
                            width: "160px",
                            height: "160px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "hidden",
                            borderRadius:
                              selectedFrame === "frameBox circularFrame"
                                ? "50%"
                                : selectedFrame === "frameBox"
                                  ? "12px"
                                  : "0",
                            clipPath:
                              selectedFrame === "frameBox circularFrame"
                                ? "circle(50% at center)"
                                : "none",
                          }}
                        />
                      </div>
                    </div>

                    <div className="social-icons margin_clssss">
                      {businessTypes2.map((item, index) => {
                        if (index < 4) {
                          return (
                            <img
                              key={index}
                              src={businessImage2 + item.review_logo}
                              alt={item.review_name}
                              title={item.review_name}
                            ></img>
                          );
                        }
                      })}
                    </div>
                    <div className="preview-footer">
                      Powered by Your <span>Wowreviews</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pre_next_bttn_div step8NextBTTn">
          <button className="prevBtn" onClick={onBack}>
            <img
              src={leftArrowSvg}
              alt="left"
              title="left"
              className="leftArrowSvg"
            />
            Back
          </button>
          <button className="nextBtn" onClick={handleNext}>
            Next
            <img
              src={rightArrowSvg}
              alt="right"
              title="right"
              className="right_arrw_svg"
            />
          </button>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={handlePreviewMobile}
        centered
        backdrop="static"
      >
        <Modal.Body style={{ position: "relative" }}>
          <X
            size={25}
            onClick={handlePreviewMobile}
            className="close_model_div"
          />

          <div className="step7Div ">
            <div className="qrScreenMobile m-auto">
              <div className="logoSection">
                <div className="logoCircle">
                  <img
                    src={logo}
                    className="dummyBussinesLogo"
                    title="Bussiness Logo"
                    alt="Logo"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = brand_logo;
                    }}
                  />
                </div>
                <div className="businessInfo">
                  <h2>{bussinesText}</h2>
                  <p>{tagLine}</p>
                </div>
              </div>
              <div
                className="feedbackSection"
                style={{ backgroundColor: bgColor }}
              >
                <p style={{ color: styles.textColor }}>
                  Please Provide your valuable
                </p>
                <h1 style={{ color: styles.textColor }}>Feedback</h1>
              </div>
              <div className="qrCodeContainer">
                <div
                  className={selectedFrame}
                  style={{
                    ...getFrameStyles(),
                    clipPath:
                      selectedFrame === "frameBox circularFrame"
                        ? "circle(50% at center)"
                        : "none",
                  }}
                >
                  <div
                    ref={modalQrCodeRef}
                    style={{
                      width: "160px",
                      height: "160px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                      borderRadius:
                        selectedFrame === "frameBox circularFrame"
                          ? "50%"
                          : selectedFrame === "frameBox"
                            ? "12px"
                            : "0",
                      clipPath:
                        selectedFrame === "frameBox circularFrame"
                          ? "circle(50% at center)"
                          : "none",
                    }}
                  />
                </div>
              </div>

              <div className="social-icons margin_clssss">
                {businessTypes2.map((item, index) => {
                  if (index < 4) {
                    return (
                      <img
                        key={index}
                        src={businessImage2 + item.review_logo}
                        alt={item.review_name}
                        title={item.review_name}
                      ></img>
                    );
                  }
                })}
              </div>
              <div className="preview-footer">
                Powered by Your <span>Wowreviews</span>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
